import { c as _c } from "react/compiler-runtime";
import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { inter } from '@/theme/utils/font.utils';
import { cn } from '@/utils/shad';
type LiveActivityEmptyStateProps = {
  Icon: LucideIcon;
  title: string;
  /** Omit to show title only. */
  description?: string;
  /** Rendered below the description (e.g. primary CTA). */
  footer?: ReactNode;
  className?: string;
  /** Merged onto the description paragraph (e.g. max-width, whitespace-pre-line). */
  descriptionClassName?: string;
};
export function LiveActivityEmptyState(t0) {
  const $ = _c(18);
  const {
    Icon,
    title,
    description,
    footer,
    className,
    descriptionClassName
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("px-8 pt-1", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== Icon) {
    t2 = <Icon className="mt-5 mb-3 text-foreground" size={20} strokeWidth={1.5} aria-hidden={true} />;
    $[2] = Icon;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn(inter.className, "text-[16px] leading-snug font-normal text-foreground");
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== title) {
    t4 = <p className={t3}>{title}</p>;
    $[5] = title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== description || $[8] !== descriptionClassName) {
    t5 = description ? <p className={cn(inter.className, "mt-1.5 max-w-130 text-[12px] leading-snug font-normal text-muted-foreground", descriptionClassName)}>{description}</p> : null;
    $[7] = description;
    $[8] = descriptionClassName;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== footer) {
    t6 = footer ? <div className="mt-4 w-full max-w-130">{footer}</div> : null;
    $[10] = footer;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
    t7 = <div className={t1}>{t2}{t4}{t5}{t6}</div>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}